import React, { useState } from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../layout";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import styles from './landing.module.scss'

const Landing = (props) => {
  const [searchQuery, setSearchQuery] = useState('')
  const postEdges = props.data.allMarkdownRemark.edges.filter(edge => {
    const keywords = searchQuery.split(' ')
    const regex = new RegExp(keywords.join('|'), 'i')
    return regex.test(edge.node.frontmatter.title) | regex.test(edge.node.frontmatter.description) | regex.test(edge.node.excerpt)
  });
  return (
    <Layout>
      <div className="landing-container">
        <div className="posts-container">
          <Helmet title={config.siteTitle} />
          <SEO />
          <div className={styles.panel}>
            <input
              type="text"
              name="search"
              id="search"
              onChange={e => setSearchQuery(e.target.value)}
              placeholder="搜尋" />
          </div>

          <PostListing postEdges={postEdges} />
        </div>
      </div>
    </Layout>
  );
}

export default Landing;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query LandingQuery {
    allMarkdownRemark(sort: { fields: [fields___date], order: DESC }) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover
            date
            description
          }
        }
      }
    }
  }
`;
